export default "__VITE_ASSET__05a0a2f6__"